import React from 'react';
import { Selector } from './Selector/Selector';
export const SubtitlesSelector = _ref => {
  let {
    visible,
    onBackButtonClick
  } = _ref;
  const options = [{
    value: 'ua',
    displayText: 'Ukrainian'
  }, {
    value: 'en',
    displayText: 'English'
  }];
  return /*#__PURE__*/React.createElement(Selector, {
    visible: visible,
    onBackButtonClick: onBackButtonClick,
    options: options,
    onSelect: () => {},
    selectedValue: "ua",
    backButtonText: "Quality"
  });
};
//# sourceMappingURL=SubtitlesSelector.js.map